
import { defineComponent } from 'vue';

import EpicContent from '../components/epic-content.vue';

export default defineComponent({
	components: {
		EpicContent
	}
})
